module.exports = __webpack_public_path__ + "img/stopped.1619ce40.svg";